/* redesign-pdp-art.js — portal an open <details> panel to the top of the
   section's empty half.
   ---------------------------------------------------------------------------
   WHY THIS IS JS AND NOT CSS (read before "simplifying" it)

   Brandon wanted the expandable panel beside the copy and pinned to the TOP of
   the section. Absolute positioning could not get there. The panel kept being
   captured by an ancestor containing block, and it was a different cause each
   time:
     1. .rd-vk-more had position:relative      (removed)
     2. .rd-pdpdesc__article inherits transform from .rd-reveal
     3. ...and will-change: transform, which ALSO creates a containing block
     4. ...and a running keyframe animation with a transform, fill-mode both
   Each fix revealed the next. Any of those returning would silently re-break
   it, and the copy column is not a stable anchor anyway — the <details> sits
   near its bottom, so "top: 0" meant "next to the button", not "top of
   section".

   So: on open, MOVE the panel's body into a host element that is a direct
   child of the section, sits in the empty half, and is anchored to the
   section's own top. On close, move it back so the markup and the mobile
   accordion are untouched. Deterministic, no containing-block archaeology.

   Degrades safely: no JS -> native inline <details>, exactly as before.
*/
(function () {
  'use strict';

  var MIN = 1200; // below this the section is too narrow for a side panel

  function init(section) {
    if (section.dataset.pdpartPanelReady) return;
    section.dataset.pdpartPanelReady = '1';

    var host = section.querySelector('[data-pdpart-panel]');
    if (!host) return;

    var open = [];

    function park(details) {
      var body = details.__rdBody;
      if (!body) return;
      details.appendChild(body);          // back to native position
      details.__rdBody = null;
      var i = open.indexOf(details);
      if (i > -1) open.splice(i, 1);
      if (!open.length) host.hidden = true;
    }

    function lift(details) {
      var body = details.querySelector(':scope > .rd-vk-more__body');
      if (!body) return;
      // One panel at a time — two stacked in the same slot would overlap.
      open.slice().forEach(function (other) {
        if (other !== details) { other.open = false; park(other); }
      });
      details.__rdBody = body;
      host.innerHTML = '';
      host.appendChild(body);
      host.hidden = false;
      if (open.indexOf(details) === -1) open.push(details);
    }

    function sync(details) {
      if (details.open && window.innerWidth >= MIN) lift(details);
      else park(details);
    }

    var items = section.querySelectorAll('.rd-vk-more');
    Array.prototype.forEach.call(items, function (d) {
      d.addEventListener('toggle', function () { sync(d); });
    });

    // Crossing the breakpoint must hand control back to the native accordion,
    // otherwise a resize leaves the body orphaned in the host on mobile.
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        Array.prototype.forEach.call(items, sync);
      }, 150);
    });
  }

  function boot() {
    var sections = document.querySelectorAll('.rd-pdpart');
    Array.prototype.forEach.call(sections, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme editor re-renders a section without a full page load.
  document.addEventListener('shopify:section:load', boot);
})();
